import React from 'react';
import { SxStyle } from '../../../../types';
import { bottomBarIconsMap } from '../icons';
import { AppConfigBottomBatItemIconsMapKeys } from '../types';
import Box from '@mui/material/Box';
import { useConfig } from '../../../../contexts/config';

const styles: SxStyle = {
  icon: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'inline-flex',
    width: '38px',
    height: '38px',
    padding: '8px',
  },
};

interface Props {
  icon: AppConfigBottomBatItemIconsMapKeys;
}

const AppMenuItemIcon = ({ icon }: Props) => {
  const { appConfig } = useConfig();

  const palette = appConfig?.appThemeV2?.palette;

  const MenuItemIconComponent = bottomBarIconsMap[icon] ? bottomBarIconsMap[icon] : null;

  return (
    <Box sx={styles.icon}>
      {MenuItemIconComponent && (
        <MenuItemIconComponent height="20" style={{ color: palette?.ID_FOREGROUND || 'white' }} />
      )}
    </Box>
  );
};

export default AppMenuItemIcon;
